module.exports = __webpack_public_path__ + "static/media/portfolio_img1.d605903d.jpg";